'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('../helpers/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function IFrameResource(_ref) {
  var resource = _ref.resource;

  return _react2.default.createElement('iframe', {
    style: _styles.vastBaseStyle,
    src: resource.getValue()
  });
}

IFrameResource.propTypes = {
  resource: _react2.default.PropTypes.object.isRequired
};

exports.default = IFrameResource;
//# sourceMappingURL=iframe-resource.js.map


// WEBPACK FOOTER //
// ./src/resources/iframe-resource.js